module.exports = "//static.hsappstatic.net/conversations-embed/static-1.26566/sass/messagesWidgetShell.sass"